import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgTwitterIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M.07.103C.133.19 12.346 17.968 12.456 18.128l.038.056-6.176 7.177A17326.58 17326.58 0 0 1 .07 32.623l-.072.084h2.824l5.46-6.347a3539.94 3539.94 0 0 1 5.466-6.347c.004 0 1.969 2.856 4.366 6.347l4.36 6.347h9.528l-.038-.058c-.022-.03-2.934-4.268-6.47-9.416-3.537-5.148-6.432-9.369-6.432-9.381-.001-.01 2.672-3.128 5.939-6.925C28.267 3.129 30.943.017 30.944.01 30.947.005 30.316 0 29.543 0h-1.407l-5.165 6.003c-2.84 3.301-5.17 6.004-5.178 6.005-.006.003-1.869-2.699-4.138-6.001L9.529 0H0L.07.103Zm8.92 3.186c3.785 5.412 19.127 27.362 19.135 27.374.008.013-.426.017-2.156.017h-2.166l-4.547-6.503L9.281 9.908c-2.985-4.27-5.428-7.77-5.428-7.776 0-.007.911-.012 2.16-.012h2.159l.819 1.17Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgTwitterStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgTwitterIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const TwitterIcon: any = SvgTwitterStyle;
export default TwitterIcon;
